import { auth } from '../firebase';
import { API_BASE_URL } from '../config';
import { writeAuditLogSafe } from './auditLogService';

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
};

export const deleteUser = async ({ uid }) => {
  const targetUid = String(uid || '').trim();
  if (!targetUid) {
    const err = new Error('Missing user id.');
    err.code = 'MISSING_UID';
    throw err;
  }

  const currentUser = auth.currentUser;
  if (!currentUser) {
    const err = new Error('Not signed in.');
    err.code = 'AUTH_REQUIRED';
    throw err;
  }

  const idToken = await currentUser.getIdToken(true);
  const storedUser = getStoredUser();
  const actor = {
    uid: currentUser.uid || null,
    email: currentUser.email || 'unknown',
    role: storedUser?.role || 'unknown',
    name: storedUser?.name || null,
    username: storedUser?.username || null,
    isAuthenticated: true,
  };

  const resp = await fetch(`${API_BASE_URL}/api/users/${encodeURIComponent(targetUid)}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  const payload = await resp.json().catch(() => ({}));
  if (!resp.ok || payload?.ok !== true) {
    const message = payload?.error || 'Failed to delete user.';

    await writeAuditLogSafe({
      action: 'User deletion failed',
      details: message,
      severity: 'Warning',
      category: 'user_management',
      outcome: 'failure',
      actor,
      resource: {
        type: 'user',
        id: targetUid,
        name: null,
        path: `/api/users/${encodeURIComponent(targetUid)}`,
      },
      tags: ['user-management', 'delete', 'failed'],
    });

    const err = new Error(message);
    err.code = 'USER_DELETE_FAILED';
    throw err;
  }

  await writeAuditLogSafe({
    action: 'User deleted',
    details: `Deleted user account with uid ${targetUid}.`,
    severity: 'Info',
    category: 'user_management',
    outcome: 'success',
    actor,
    resource: {
      type: 'user',
      id: targetUid,
      name: null,
      path: `/api/users/${encodeURIComponent(targetUid)}`,
    },
    tags: ['user-management', 'delete', 'success'],
  });

  return payload;
};